import { lazy } from "react";
import ShowEmployeeAttendance from "../../../../Pages/employeeApp/EmployeeAttendance/ShowEmployeeAttendance";
import WriteToHrApp from "../../../../Pages/employeeApp/FeedbackScreen/WriteToHrApp";
import ShowIssue from "../../../../Pages/employeeApp/FeedbackScreen/ShowIssue";

const EmpDashboard = lazy(
    () => import("../../../../Pages/employeeApp/empDashboard/EmpDashboard"),
);
const TripDetails = lazy(
    () => import("../../../../Pages/employeeApp/travelpage/TripDetails"),
);
const TravelRequest = lazy(
    () => import("../../../../Pages/employeeApp/travelpage/TravelRequest"),
);
const AddNewTrip = lazy(
    () => import("../../../../Pages/employeeApp/travelpage/AddNewTrip"),
);
const CurrentTravel = lazy(
    () => import("../../../../Pages/employeeApp/travelpage/CurrentTravel"),
);
const SuccessiveTravel = lazy(
    () => import("../../../../Pages/employeeApp/travelpage/SuccessiveTravel"),
);
const ShowTripRecordAttachement = lazy(
    () =>
        import("../../../../Pages/employeeApp/travelpage/ShowTripRecordAttachement"),
);
const UploadExtraPhoto = lazy(
    () => import("../../../../Pages/employeeApp/travelpage/UploadExtraPhoto"),
);
const TaDaDashboard = lazy(
    () => import("../../../../Pages/employeeApp/TaDaManagement/TaDaDashboard"),
);

const RequestTaDa = lazy(
    () => import("../../../../Pages/employeeApp/TaDaManagement/RequestTaDa"),
);

const ShowTaDaData = lazy(
    () => import("../../../../Pages/employeeApp/TaDaManagement/ShowTaDaData"),
);

const RequestAssetDashboard = lazy(
    () =>
        import("../../../../Pages/employeeApp/AssetsPanel/RequestAssetDashboard"),
);

const RequestAsset = lazy(
    () => import("../../../../Pages/employeeApp/AssetsPanel/RequestAsset"),
);
const VerifyAssetOtp = lazy(
    () => import("../../../../Pages/employeeApp/AssetsPanel/VerifyAssetOtp"),
);

const AssignedAssets = lazy(
    () => import("../../../../Pages/employeeApp/AssetsPanel/AssignedAssets"),
);

const FeedBackScreen = lazy(
    () =>
        import("./../../../../Pages/employeeApp/FeedbackScreen/FeedBackScreen"),
);

const FeedBackForm = lazy(
    () => import("./../../../../Pages/employeeApp/FeedbackScreen/FeedBackForm"),
);
const EmpCoordinatorDashBorad = lazy(
    () =>
        import("../../../../Pages/employeeApp/EmpCoordinatorpanel/EmpCoordinatorDashBorad"),
);

const MemberList = lazy(
    () =>
        import("../../../../Pages/employeeApp/EmpCoordinatorpanel/MemberList"),
);
const ShowTravelAttendanceCoordinator = lazy(
    () =>
        import("../../../../Pages/employeeApp/EmpCoordinatorpanel/ShowTravelAttendanceCoordinator"),
);

const CheckCoordinatorLocationTravel = lazy(
    () =>
        import("../../../../Pages/employeeApp/EmpCoordinatorpanel/CheckCoordinatorLocationTravel"),
);
const ShowPunchTrackLocation = lazy(
    () =>
        import("../../../../Pages/employeeApp/EmpCoordinatorpanel/ShowPunchTrackLocation"),
);
const ShowTravelCoordinater = lazy(
    () =>
        import("../../../../Pages/employeeApp/EmpCoordinatorpanel/CoordinatorTravelApprovel/ShowTravelCoordinater"),
);
const ApproveSubcoordinatorTravel = lazy(
    () =>
        import("../../../../Pages/employeeApp/EmpCoordinatorpanel/CoordinatorTravelApprovel/ApproveSubcoordinatorTravel"),
);

const ExtendTravelEndDate = lazy(
    () =>
        import("../../../../Pages/employeeApp/EmpCoordinatorpanel/CoordinatorTravelApprovel/ExtendTravelEndDate"),
);
const TadaApprovelCoordinator = lazy(
    () =>
        import("../../../../Pages/employeeApp/EmpCoordinatorpanel/TaDaApproveCoordinator/TadaApprovelCoordinator"),
);
const ShowtadacordinatorallDetails = lazy(
    () =>
        import("../../../../Pages/employeeApp/EmpCoordinatorpanel/TaDaApproveCoordinator/ShowtadacordinatorallDetails"),
);
const ChangePassword = lazy(
    () => import("../../../../Pages/employeeApp/empDashboard/ChangePassword"),
);

export const EmployeeRoute = [
    { path: "emp/empDashboard", element: <EmpDashboard /> },
    { path: "emp/showemployeeattendance", element: <ShowEmployeeAttendance /> },
    { path: "emp/tripdetails", element: <TripDetails /> },
    { path: "emp/travelrequest", element: <TravelRequest /> },
    { path: "emp/addtrip", element: <AddNewTrip /> },
    { path: "emp/currenttravel", element: <CurrentTravel /> },
    { path: "emp/succesivetravel", element: <SuccessiveTravel /> },
    {
        path: "emp/showtripRecordattachement",
        element: <ShowTripRecordAttachement />,
    },
    { path: "emp/uploadphoto", element: <UploadExtraPhoto /> },
    { path: "emp/tadadashboard", element: <TaDaDashboard /> },
    { path: "emp/tadarequest", element: <RequestTaDa /> },
    { path: "emp/showtadaData", element: <ShowTaDaData /> },
    { path: "emp/assets", element: <RequestAssetDashboard /> },
    { path: "emp/requestassets", element: <RequestAsset /> },
    { path: "emp/otpvarify", element: <VerifyAssetOtp /> },
    { path: "emp/assiginasset", element: <AssignedAssets /> },
    { path: "emp/feedbackscreen", element: <FeedBackScreen /> },
    { path: "emp/feedback-form", element: <FeedBackForm /> },
    { path: "emp/corodinatorpanl", element: <EmpCoordinatorDashBorad /> },
    { path: "emp/memberlist", element: <MemberList /> },
    {
        path: "emp/travelAttendancecordinator",
        element: <ShowTravelAttendanceCoordinator />,
    },
    { path: "emp/checklocation", element: <CheckCoordinatorLocationTravel /> },
    {
        path: "emp/show-punch-track-location",
        element: <ShowPunchTrackLocation />,
    },
    { path: "emp/co-showtravelrequest", element: <ShowTravelCoordinater /> },
    {
        path: "emp/approve-subordinator-travel",
        element: <ApproveSubcoordinatorTravel />,
    },
    { path: "emp/extendEnd-date", element: <ExtendTravelEndDate /> },
    { path: "emp/ta-da-ApprovelRequest", element: <TadaApprovelCoordinator /> },
    {
        path: "emp/approve-ta-amount",
        element: <ShowtadacordinatorallDetails />,
    },
    {
        path: "emp/password-change",
        element: <ChangePassword />,
    },
   
    {
        path: "emp/Show-your-issue",
        element: <ShowIssue />,
    },
     {
        path:"emp/write-to-hr",
        element:<WriteToHrApp/>
    },
];
